export const BASE_URL = 'http://shop-counters.ru';
// export const BASE_URL = 'http://127.0.0.1:8000';

export const SHOP_NAME = 'Shop';
export const COMPANY_SELLER = {
  inn: "000000000000",
  kpp: "000000000",
  ogrn: "000000000000000",
  name: "OOO 'My Shop'",
  short_name: "My Shop",
  adress: "000000, г.Город, ул.Улица, д.000/000, стр.0, вл.0 оф.000",
  bik: "000000000",
  bank_name: "ПАО СуперБанк г.Город",
  korr_schet: "00000000000000000000",
  rass_schet: "00000000000000000000",
  email: "info@my_shop.ru",
  director_name: "Фамилия Имя Отчество",
  director_post: "Директор",
  director_footing: "устава"
};

export const Portal = {
  ApiResult: 'ApiResult',
  EditOrder: 'EditOrder',
  Slideshow: 'Slideshow',
  Product: 'Product',
  Confirm: 'Confirm',
  Buttons: 'Buttons',
  Empty: '',
}

export const TypeConfirm = {
  RemoveFirm: 'RemoveFirm',
  DeleteMe: 'DeleteMe',
  ChangePassword: 'ChangePassword',
  ChangeEmail: 'ChangeEmail',
  RemoveProductFromCart: 'RemoveProductFromCart',
  RemoveActiveFromCart: 'RemoveActiveFromCart',
  CancelOrder: 'CancelOrder'
}

export const TypeEditOrder = {
  EditComment: 'EditComment',
  EditFirm: 'EditFirm',
  EditProducts: 'EditProducts',
  EditShipping: 'EditShipping'
}

export const DIRECTOR_POSTS = {
  Director: 'Директор',
  GeneralDirector: 'Генеральный директор',
  Predsedatel: 'Председатель',
  Manager: 'Управляющий',
  Ip: 'ИП',
  Zaved: 'Заведующий',
  GeneralDoctor: 'Главный врач'
}
export const DIRECTOR_FOOTINGS = {
  Ustav: 'устава',
  Prikaz: 'приказа',
  Doverennost: 'доверенности',
  Reshenie: 'решения',
  Svidetelstvo: 'свидетельства',
}

export const ROUTES_CONST = [
  {
    path: "*", breadcrumb: "Страница не найдена",
    metaTitle: "Страница не найдена",
    metaDescription: 'Описание для Страница не найдена',
    metaKeywords: 'Ключевые слова для Страница не найдена',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/", breadcrumb: "Главная",
    metaTitle: `Главная страница интернет-магазина`,
    metaDescription: 'Описание для Главная',
    metaKeywords: 'Ключевые слова для Главная',
    metaRobots: 'index, follow'
  },
  {
    path: "/register", breadcrumb: "Регистрация",
    metaTitle: `Регистрация на сайте`,
    metaDescription: 'Описание для Регистрация',
    metaKeywords: 'Ключевые слова для Регистрация',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/activate/:uid/:token", breadcrumb: "Активация учётной записи",
    metaTitle: "Активация учётной записи",
    metaDescription: 'Описание для Активация учётной записи',
    metaKeywords: 'Ключевые слова для Активация учётной записи',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/login", breadcrumb: "Авторизация",
    metaTitle: `Авторизация на сайте`,
    metaDescription: 'Описание для Авторизация',
    metaKeywords: 'Ключевые слова для Авторизация',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/forgot-password", breadcrumb: "Восстановление пароля",
    metaTitle: "Восстановление пароля",
    metaDescription: 'Описание для Восстановление пароля',
    metaKeywords: 'Ключевые слова для Восстановление пароля',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/resend-activation", breadcrumb: "Запрос активации аккаунта",
    metaTitle: "Запрос активации аккаунта",
    metaDescription: 'Описание для Запрос активации аккаунта',
    metaKeywords: 'Ключевые слова для Запрос активации аккаунта',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/reset-password", breadcrumb: "Сброс пароля",
    metaTitle: "Сброс пароля",
    metaDescription: 'Описание для Сброс пароля',
    metaKeywords: 'Ключевые слова для Сброс пароля',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/password/reset/confirm/:uid/:token", breadcrumb: "Новый пароль",
    metaTitle: "Новый пароль",
    metaDescription: 'Описание для Новый пароль',
    metaKeywords: 'Ключевые слова для Новый пароль',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/agreement", breadcrumb: "Пользовательское соглашение",
    metaTitle: "Пользовательское соглашение",
    metaDescription: 'Описание для Пользовательское соглашение',
    metaKeywords: 'Ключевые слова для Пользовательское соглашение',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/personal-data", breadcrumb: "Политика обработки персональных данных",
    metaTitle: "Политика обработки персональных данных",
    metaDescription: 'Описание для Политика обработки персональных данных',
    metaKeywords: 'Ключевые слова для Политика обработки персональных данных',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/cookie", breadcrumb: "Политика использования файлов Cookie",
    metaTitle: "Политика использования файлов Cookie",
    metaDescription: 'Описание для Политика использования файлов Cookie',
    metaKeywords: 'Ключевые слова для Политика использования файлов Cookie',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/about", breadcrumb: "О нас",
    metaTitle: `О компании`,
    metaDescription: 'Описание для О нас',
    metaKeywords: 'Ключевые слова для О нас',
    metaRobots: 'index, follow'
  },
  {
    path: "/pay", breadcrumb: "Оплата",
    metaTitle: "Способы оплаты",
    metaDescription: 'Описание для Оплата',
    metaKeywords: 'Ключевые слова для Оплата',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/delivery", breadcrumb: "Доставка",
    metaTitle: "Доставка",
    metaDescription: 'Описание для Доставка',
    metaKeywords: 'Ключевые слова для Доставка',
    metaRobots: 'index, follow'
  },
  {
    path: "/contacts", breadcrumb: "Контакты",
    metaTitle: "Контакты",
    metaDescription: 'Описание для Контакты',
    metaKeywords: 'Ключевые слова для Контакты',
    metaRobots: 'index, follow'
  },
  {
    path: "/docs", breadcrumb: "Документация",
    metaTitle: "Документация",
    metaDescription: 'Описание для Документация',
    metaKeywords: 'Ключевые слова для Документация',
    metaRobots: 'index, follow'
  },
  {
    path: "/catalog", breadcrumb: "Каталог",
    metaTitle: `Каталог товаров`,
    metaDescription: 'Описание для Каталог',
    metaKeywords: 'Ключевые слова для Каталог',
    metaRobots: 'index, follow'
  },
  {
    path: "/orders", breadcrumb: "Заказы",
    metaTitle: "Заказы",
    metaDescription: 'Описание для Заказы',
    metaKeywords: 'Ключевые слова для Заказы',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/orders/:token", breadcrumb: "Информация о заказе",
    metaTitle: 'Информация о заказе',
    metaDescription: 'Описание заказа',
    metaKeywords: 'Ключевые слова для заказа',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/profile/firms", breadcrumb: "Организации",
    metaTitle: "Организации",
    metaDescription: 'Описание для Организации',
    metaKeywords: 'Ключевые слова для Организации',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/profile", breadcrumb: "Аккаунт",
    metaTitle: "Аккаунт",
    metaDescription: 'Описание для Аккаунт',
    metaKeywords: 'Ключевые слова для Аккаунт',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/profile/me", breadcrumb: "Данные пользователя",
    metaTitle: "Данные пользователя",
    metaDescription: 'Описание для Данные пользователя',
    metaKeywords: 'Ключевые слова для Данные пользователя',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/profile/set_password", breadcrumb: "Смена пароля",
    metaTitle: "Смена пароля",
    metaDescription: 'Описание для Смена пароля',
    metaKeywords: 'Ключевые слова для Смена пароля',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/profile/delete", breadcrumb: "Удаление аккаунта",
    metaTitle: "Удаление аккаунта",
    metaDescription: 'Описание для Удаление аккаунта',
    metaKeywords: 'Ключевые слова для Удаление аккаунта',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/profile/set_email", breadcrumb: "Смена почты",
    metaTitle: "Смена почты",
    metaDescription: 'Описание для Смена почты',
    metaKeywords: 'Ключевые слова для Смена почты',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/profile/add_firm", breadcrumb: "Добавление организации",
    metaTitle: `Добавление организации`,
    metaDescription: 'Описание для Добавление организации',
    metaKeywords: 'Ключевые слова для Добавление организации',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/favorite", breadcrumb: "Избранное",
    metaTitle: "Избранное",
    metaDescription: 'Описание для Избранное',
    metaKeywords: 'Ключевые слова для Избранное',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/cart", breadcrumb: "Корзина",
    metaTitle: "Корзина",
    metaDescription: 'Описание для Корзина',
    metaKeywords: 'Ключевые слова для Корзина',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/new_order", breadcrumb: "Оформление заказа",
    metaTitle: "Оформление заказа",
    metaDescription: 'Описание для Оформление заказа',
    metaKeywords: 'Ключевые слова для Оформление заказа',
    metaRobots: 'noindex, nofollow'
  },
  {
    path: "/products", breadcrumb: "Товары",
    metaTitle: "Товары",
    metaDescription: '',
    metaKeywords: '',
    metaRobots: ''
  },
  // {
  //   path: "/products/:token", breadcrumb: "Товар",
  //   metaTitle: "Подробная информация о товаре",
  //   metaDescription: '',
  //   metaKeywords: '',
  //   metaRobots: ''
  // },
  {
    path: "/news", breadcrumb: "Новости и статьи",
    metaTitle: `Новости компании`,
    metaDescription: 'Описание для Новости',
    metaKeywords: 'Ключевые слова для Новости',
    metaRobots: 'index, follow'
  },
  {
    path: "/news/:token", breadcrumb: "Новость",
    metaTitle: "Интересная новость",
    metaDescription: '',
    metaKeywords: '',
    metaRobots: ''
  },
  {
    path: "/catalog/new", breadcrumb: "Новинки",
    metaTitle: `Новинки`,
    metaDescription: 'Описание для Новинки',
    metaKeywords: 'Ключевые слова для Новинки',
    metaRobots: 'index, follow'
  },
  {
    path: "/catalog/sale", breadcrumb: "Распродажа",
    metaTitle: `Распродажа`,
    metaDescription: 'Описание для Распродажа',
    metaKeywords: 'Ключевые слова для Распродажа',
    metaRobots: 'index, follow'
  },
]

export const WIDTH_XL = { name: "1280", width: 1280 };
export const WIDTH_LG = { name: "990", width: 990 };
export const WIDTH_MD = { name: "768", width: 768 };
export const WIDTH_SM = { name: "540", width: 540 };

export const PRODUCTS_IN_PAGE = 100;

export const ORDERS_IN_PAGE = 10;

export const FIRMS_IN_PAGE = 10;

export const BUTTON_MORE_TEXT = '';

export const UPDATE_USER_MESSAGE = 'Ваши данные изменены';

export const SERVER_ERROR = `Во время запроса произошла ошибка. Возможно,
проблема с соединением или сервер недоступен. Подождите немного и попробуйте ещё раз.`;

export const NOT_EQUAL_PASSWORDS = 'Пароли не совпадают.';
export const NOT_EQUAL_EMAILS = 'Почты не совпадают.';

// export const LOGIN_BUTTON_TEXT = 'Войти';
// export const WAIT_LOGIN_BUTTON_TEXT = 'Вход...';
// export const REGISTER_BUTTON_TEXT = 'Зарегистрироваться';
// export const WAIT_REGISTER_BUTTON_TEXT = 'Регистрация...';

export const TITLE_FIRM = 'Добавление организации';
export const TITLE_ERROR = 'Ошибка';
export const TITLE_NOTIFICATION = 'Уведомление';
export const TITLE_CART_CHOICE = 'Выберите действие';
export const TITLE_EDIT_DATA = 'Редактирование данных';
export const TITLE_EDIT_ORDER_COMMENT = 'Изменение комментария к заказу';
export const TITLE_EDIT_ORDER_SHIPPING = 'Изменение доставки в заказе';
export const TITLE_EDIT_ORDER_FIRM = 'Изменение плательщика в заказе';
export const TITLE_EDIT_ORDER_PRODUCTS = 'Изменение товаров в заказе';

export const TEXT_SET_EMAIL_SUCCESS = 'Адрес вашей почты успешно изменён.';
export const TEXT_DELETE_ME_SUCCESS = 'Ваш аккаунт удалён.';
export const TEXT_RESET_PASSWORD = 'Ваш пароль успешно изменён.';
export const TEXT_PATCH_ME_SUCCESS = 'Ваши данные успешно изменены.';
export const TEXT_ACTIVATION_SUCCESS = `Ваша учётная запись активирована.
Если учётная запись была создана при заказе без регистрации -
сбросьте пароль.`;
export const TEXT_REGISTER_SUCCESS = `На указанный E-mail было выслано сообщение.
Проверьте почту и следуйте полученной инструкции. Если письмо не приходит - проверьте папку Спам.`;
export const FORGOT_PASSWORD_SUCCESS = `На указанный при регистрации E-mail было выслано сообщение.
Проверьте почту и следуйте полученной инструкции. Если письмо не приходит - проверьте папку Спам.`;
export const RESEND_ACTIVATION_SUCCESS = `На указанный при регистрации E-mail было выслано сообщение.
Проверьте почту и следуйте полученной инструкции. Если письмо не приходит - проверьте папку Спам.`;
export const TEXT_QUICK_REGISTER_SUCCESS = 'Ваши контактные данные приняты.';
export const TITLE_CONFIRM = 'Требуется подтверждение';
export const TEXT_ERROR_REPEAT = 'Повторить можно только полученный заказ.';
export const TEXT_DELETE_FIRM = 'Вы уверены, что хотите удалить организацию из вашего списка?';
export const TEXT_CANCEL_ORDER = 'Вы уверены, что хотите отменить заказ?';
export const TEXT_REMOVE_PRODUCT = 'Вы уверены, что хотите удалить продукт из вашей корзины?';
export const TEXT_REMOVE_ACTIVE_PRODUCTS = 'Вы уверены, что хотите удалить выбранные продукты из вашей корзины?';
export const TEXT_CHANGE_EMAIL = 'Вы уверены, что хотите изменить адрес электронной почты?';
export const TEXT_CHANGE_PASSWORD = 'Вы уверены, что хотите изменить пароль?';
export const TEXT_DELETE_ME = 'Вы уверены, что хотите удалить аккаунт?';
export const TEXT_ERROR_NOT_AVAILABLE_PRODUCTS = 'К сожалению, среди выбранных товаров сейчас нет доступных для заказа.';
export const TEXT_NOTIFICATION_ORDER_STRUCTURE = 'Именился состав заказа, проверьте перед подтверждением.';
export const TEXT_NOTIFICATION_MAX_PRODUCTS = `К сожалению, корзина заполнена. Если Вы хотите заказать больше товаров,
оформите заказ а затем добавьте новые товары в корзину.`;

export const TEXT_BILL_REQUESTED = 'Отправлен запрос на счёт.';
export const TEXT_INVOICE_REQUESTED = 'Отправлен запрос на товарную накладную.';
export const TEXT_FILE_UPLOADED = 'Документ загружен.';
export const TEXT_BILL_CONFIRMED = 'Счёт подтвержден.';
export const TEXT_ENTRANCE_CONFIRMED = 'Поступление денежных средств внесено.';
export const TEXT_SET_DEF_PAYMENT_CONFIRMED = 'Отсрочка оплаты изменена.';
export const TEXT_EDIT_DATA_CONFIRMED = 'Данные успешно изменены.';
export const TEXT_EDIT_ORDER_CONFIRMED = 'Заказ успешно изменён.';
export const TEXT_AWAIT_RECEIPT_CONFIRMED = 'Заказ ожидает получения покупателем.';
export const TEXT_RECEIVED_CONFIRMED = 'Покупатель получил заказ.';

export const FIRST_NAME_MIN_LENGTH = 2;
export const FIRST_NAME_MAX_LENGTH = 34;
export const LAST_NAME_MIN_LENGTH = 2;
export const LAST_NAME_MAX_LENGTH = 34;
export const SURNAME_MIN_LENGTH = 0;
export const SURNAME_MAX_LENGTH = 34;
export const PASSWORD_MIN_LENGTH = 8;

export const MAX_PROD_IN_CART = 20;


export const START_CARDS_MORE_1280_PX = 12;
export const START_CARDS_MORE_990_PX = 9;
export const START_CARDS_MORE_665_PX = 8;
export const START_CARDS_MORE_320_PX = 5;

export const ADD_CARDS_MORE_1280_PX = 4;
export const ADD_CARDS_MORE_990_PX = 3;
export const ADD_CARDS_MORE_665_PX = 2;
export const ADD_CARDS_MORE_320_PX = 2;

export const WIDTH_1280_PX_4_CARDS = 1280;
export const WIDTH_990_PX_3_CARDS = 990;
export const WIDTH_665_PX_2_CARDS = 665;
export const WIDTH_320_PX_1_CARDS = 320;

export const BLUE_INTERFACE = [
  { name: 'color5', color: '#2d9cee' },
  { name: 'color5-1', color: '#31a9ff' },
  { name: 'color5-2', color: '#2583c7' },
  { name: 'color6', color: '#00186a' }
]

export const GREEN_INTERFACE = [
  { name: 'color5', color: '#327f0f' },
  { name: 'color5-1', color: '#45ac16' },
  { name: 'color5-2', color: '#22560a' },
  { name: 'color6', color: '#1b4408' }
]

export const RED_INTERFACE = [
  { name: 'color5', color: '#7f0f0f' },
  { name: 'color5-1', color: '#ac1616' },
  { name: 'color5-2', color: '#560a0a' },
  { name: 'color6', color: '#440808' }
]

export const ORANGE_INTERFACE = [
  { name: 'color5', color: '#7f520f' },
  { name: 'color5-1', color: '#ac7316' },
  { name: 'color5-2', color: '#563b0a' },
  { name: 'color6', color: '#442c08' }
]

export const VIOLET_INTERFACE = [
  { name: 'color5', color: '#7f0f79' },
  { name: 'color5-1', color: '#ac16a5' },
  { name: 'color5-2', color: '#560a56' },
  { name: 'color6', color: '#44083e' }
]

export const STATUSES_VALUES = {
  created: "created",
  invoiced: "invoiced",
  delivery: "delivery",
  await_receipt: "await_receipt",
  received: "received",
  cancelled: "cancelled"
}

export const ORDER_STATUSES = [
  { name: 'любой статус', value: '' },
  { name: 'создан', value: 'created' },
  { name: 'выставлен счёт', value: 'invoiced' },
  { name: 'отправлен', value: 'delivery' },
  { name: 'ожидает получения', value: 'await_receipt' },
  { name: 'получен', value: 'received' },
  { name: 'отменён', value: 'cancelled' }
]

export const PAYMENT_STATUSES = [
  { name: 'любой статус', value: '' },
  { name: 'нет оплаты', value: 'not_payment' },
  { name: 'частично', value: 'payment_part' },
  { name: 'оплачен', value: 'payment' },
]

export const USER_ROLES = {
  superuser: 'superuser',
  manager: 'manager',
  buhgalter: 'buhgalter',
  customer: 'customer'
}

export const SHIPPING_TYPES = {
  selfie: 'selfie',
  courier: 'courier',
  cargo: 'cargo'
}

// ('manager', 'Менеджер'),
// ('buhgalter', 'Бухгалтер'),
// ('customer', 'Покупатель'),
// ('superuser', 'Суперюзер')

export const MAX_DEF_PAYMENT = 120;
